const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M19.78 7.28a.75.75 0 0 0-1.06-1.06l-9.47 9.47-4.47-4.47a.75.75 0 0 0-1.06 1.06l5 5a.75.75 0 0 0 1.06 0z"/></svg>';
export {
  a as w
};
